// import { showAlert, hideAlert } from './alert';
import { apiClient } from '../../utils';
import { uploadMedia, handleError } from '../';

export const editCampaign = async ({
  id,
  site,
  name,
  link_web,
  link_app,
  media,
}) => {
  try {
    // link_app
    const data = { site, name, link_web, campaign: id };
    const cmp = await apiClient.post('/merchant/campaign/edit', { data });

    if (media instanceof File) {
      const mediaPayload = { site, mc: name, campaign: media, campaignID: id };
      await uploadMedia(mediaPayload, { endpoint: '/merchant/media/upload' });
    }

    return cmp.result;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
